import { render } from "./LearningHubHeader.vue?vue&type=template&id=c8623e4a&scoped=true"
import script from "./LearningHubHeader.vue?vue&type=script&lang=js"
export * from "./LearningHubHeader.vue?vue&type=script&lang=js"

import "./LearningHubHeader.vue?vue&type=style&index=0&id=c8623e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8623e4a"]])

export default __exports__